import React, { useContext } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history'
import { AppConsumer } from './contexts/app-context';
import questionsObj from './questions.json';
import './assets/sass/main.scss';
import Menu from './components/Menu/Menu';
import Home from './components/Home/Home';
import Quiz from './components/Quiz/Quiz';
import Final from './components/Final/Final';
import NoMatch from './components/NoMatch/NoMatch';

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

const App = (props) => {
  const app = useContext(AppConsumer);
  const { locale, setCorrectAnswers, correctAnswers, switchLanguage, mobile, finished, setFinished } = app;
  const questions = questionsObj[locale].questions;
  const minimum = questionsObj[locale].minimum;
  return (
    <Router history={history}>
      <Menu history={history} locale={locale} switchLanguage={switchLanguage} />
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/quiz">
          <Quiz mobile={mobile} setFinished={setFinished} questions={questions} history={history} setCorrectAnswers={setCorrectAnswers} />
        </Route>
        <Route exact path="/final">
          <Final finished={finished} history={history} questionsCount={questions.length} correctAnswers={correctAnswers} minimum={minimum} />
        </Route>
        <Route component={NoMatch}/>
      </Switch>
    </Router>
  );
}

export default App;
